import {
  type IWidgetOption,
  type IWidgetOptionValue,
} from '../../../../Widget.ts';

export function isWidgetOptionValue(
  option: IWidgetOption,
): option is IWidgetOptionValue {
  return option.type === 'option';
}
